import React from "react";
import clsx from "classnames";
import Header from "../header/header";
import SepaHeldHero from "./SepaHeldHero";
import PartnerLogosMarquee from "./PartnerLogosMarquee";

// Light, landing-page-style auth layout modelled on sepaheld.com: the marketing
// hero on the left and an action card (login form, register form, callback
// state, …) on the right, with the partner-logo marquee underneath. Stacks to a
// single column on smaller screens so the hero/USP content stays visible.
const MarketingAuthLayout = ({children, showHeader = false, panelClassName}) => (
    <div className="relative min-h-screen overflow-hidden bg-slate-50">
        {showHeader && <Header/>}
        <div aria-hidden className="pointer-events-none absolute -top-32 right-0 h-96 w-96 rounded-full bg-violet-200/40 blur-3xl"/>
        <div aria-hidden className="pointer-events-none absolute -bottom-40 -left-20 h-96 w-96 rounded-full bg-indigo-100/50 blur-3xl"/>
        <div className="relative mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 lg:py-16">
            <div className="flex flex-col items-center gap-12 xl:flex-row xl:items-start xl:gap-16">
                <div className="order-2 w-full xl:order-1 xl:flex-1 xl:pt-4">
                    <SepaHeldHero/>
                </div>
                <div className={clsx("order-1 w-full xl:order-2 xl:max-w-136", panelClassName)}>
                    <div className="relative overflow-hidden rounded-3xl border border-slate-200 bg-white p-6 shadow-xl shadow-slate-200/60 sm:p-8 lg:p-10">
                        {children}
                    </div>
                </div>
            </div>
            <div className="mt-14 lg:mt-20">
                <PartnerLogosMarquee/>
            </div>
        </div>
    </div>
);

export default MarketingAuthLayout;
